/* eslint-disable jsx-a11y/label-has-for */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function Input({
  label,
  required,
  type,
  error: errorMessage,
  id,
  placeholder,
}) {
  const [valid, setValidity] = useState(true);
  const [error, setError] = useState(errorMessage);
  const validateEmail = (email) =>
    email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

  const validate = (e) => {
    const { value, checked } = e.target;

    if (type === 'checkbox' && required && !checked) {
      return setValidity(false);
    }

    if (required && value?.trim().length === 0) {
      return setValidity(false);
    }
    if (type === 'email') {
      const isValid = validateEmail(value);
      return setValidity(isValid);
    }

    setValidity(true);
  };
  return (
    <div className="form-input">
      <label required={required} htmlFor={id}>
        {label}
      </label>
      {type === 'textarea' ? (
        <textarea
          onInvalid={(e) => {
            e.preventDefault();
            if (e.target.id === id) {
              setError(e.target.validationMessage);
              return setValidity(false);
            }
            return setValidity(true);
          }}
          onBlur={validate}
          required={required}
          rows={5}
          placeholder={placeholder}
          name={id}
          id={id}
          minLength={100}
        />
      ) : (
        <input
          onInvalid={(e) => {
            e.preventDefault();
            if (e.target.id === id) {
              return setValidity(false);
            }
            return setValidity(true);
          }}
          onBlur={validate}
          required={required}
          type={type}
          id={id}
          name={id}
          placeholder={placeholder}
        />
      )}
      {!valid && <span>{error}</span>}
    </div>
  );
}

Input.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  type: PropTypes.oneOf(['text', 'email', 'textarea', 'checkbox']).isRequired,
  error: PropTypes.string,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};

Input.defaultProps = {
  required: false,
  error: '',
  placeholder: '',
};
